import { VerificationPhase } from './back-requirement';

// isBackRequired is a tri-state the caller passes in: null (front hasn't been verified yet,
// so we don't know), true/false (known, from evaluating front's verify response). This module
// doesn't compute that value itself — see back-requirement.js for what's deferred to later.
export const resolveConditionalBack = isBackRequired => {
  if (isBackRequired === null) {
    return {
      isBackRequired: null,
      showBackUpload: false,
      verificationPhase: VerificationPhase.FRONT_DISCOVERY,
    };
  }
  if (isBackRequired) {
    return {
      isBackRequired: true,
      showBackUpload: true,
      verificationPhase: VerificationPhase.AWAITING_BOTH,
    };
  }
  return {
    isBackRequired: false,
    showBackUpload: false,
    verificationPhase: VerificationPhase.FRONT_ONLY,
  };
};
